'use strict';

(function () {
    var x;
    /**
     * @description Check if explicit consent
     * @returns {Boolean} true if loaded
     */
    function checkConsent() {
        return window.dataLayer.some(function (event) {
            return event['consent_status']; // eslint-disable-line
        });
    }

    /**
     * @description Run auto events
     * @returns {Void} void
     */
    function runAutoEvent() {
        var oldLayer = window.dynamic_tm_data;
        var categoryPath = window.jwsdwProductDetailSettings.data.categoryPath;

        window.dataLayer.push({
            event: 'eec.productDetailImpression',
            eventCategory: 'ecommerce',
            eventAction: 'product detail impression',
            eventLabel: 'product detail page',
            eventValue: oldLayer.productPriceWithVAT,
            nonInteraction: true,
            ecommerce: {
                currencyCode: oldLayer.currency,
                detail: {
                    actionField: {
                        list: 'product detail page'
                    },
                    products: [
                        {
                            name: oldLayer.productname,
                            id: oldLayer.productid,
                            price: oldLayer.productPriceWithVAT,
                            brand: (oldLayer.productbrand || '').replace(
                                '&amp;',
                                '&'
                            ),
                            category: oldLayer.categoryid,
                            variant: oldLayer.productColorName,
                            list: 'product detail page',
                            dimension13: oldLayer.productid.split('_').shift(),
                            dimension14:
                                categoryPath[categoryPath.length - 1].id
                        }
                    ]
                }
            }
        });
    }
    if (!!window.google_tag_manager) {
        if (checkConsent()) {
            runAutoEvent();
            return;
        }
        x = window.dataLayer.push;
        window.dataLayer.push = function (obj) {
            x(obj);
            if (obj.event === 'consent_status' && obj.type === 'explicit') {
                runAutoEvent();
            }
        };
    } else {
        window.addEventListener('gtm_loaded', function () {
            if (checkConsent()) {
                runAutoEvent();
                return;
            }
            x = window.dataLayer.push;
            window.dataLayer.push = function (obj) {
                x(obj);
                if (obj.event === 'consent_status' && obj.type === 'explicit') {
                    runAutoEvent();
                }
            };
        });
    }
}());

(function (window, document, $, Swiper) { // eslint-disable-line max-statements
    var isCustomSize = window.location.hash.length && window.location.hash.indexOf('size') > -1;
    if (isCustomSize) {
        let hash = decodeURIComponent(window.location.hash)
            .replace('#size=', '')
            .split('|');
        for (let i = 0; i < $('.jwsdw-pdp-size .jwsdw-product-swatch-selectable span').length; i++) {
            for (let j = 0; j < hash.length; j++) {
                if ($($('.jwsdw-pdp-size .jwsdw-product-swatch-selectable span')[i]).text().trim() === hash[j]) {
                    $($('.jwsdw-pdp-size .jwsdw-product-swatch-selectable span')[i]).click();
                    break;
                }
            }
        }
    }

    //Inits availability update
    initAvailabilityUpdate();

    //Inits promotions update
    initPromotionsUpdate();

    //Inits image gallery swiper for mobile
    initImageGallerySwiper();

    //Inits the sticky add toc art button
    initStickyCTAs();

    //Inits SAIZ tool listener
    initSaizToolListener();

    $(document).on('click', '.jwsdw-pdp-social-twitter', function () {
        updateMetaDataSocial();

        window.open($(this).data('href'), '', 'width=700, height=700');

        /**
         * @description Method to update social meta data
         * @returns {Boolean} true
         */
        function updateMetaDataSocial() {
            var metaImage = $('head meta[property="og:image"]'),
                firstThumbnail = $(document)
                    .find('.jwsdw-pdp-thumbGalleryContainer img')
                    .first(),
                ogimageurl =
                    firstThumbnail.length > 0 && firstThumbnail.attr('src') ? firstThumbnail.attr('src') : '',
                newMetaImage = $(
                    '<meta property="og:image" content="' + ogimageurl + '"/>'
                );

            if (metaImage.length > 0) {
                metaImage.replaceWith(newMetaImage);
            } else {
                $('head').append(newMetaImage);
            }

            if ($('head meta[property="og:type"]').length === 0) {
                $('head').append(
                    $('<meta property="og:type" content="product"/>')
                );
            }

            return true;
        }
    });

    $('#jws-pdp-showLess').on('click', function () {
        $('#jwsdw-pdp-productShortDesc').toggleClass('jws-hidden');
        $('#jwsdw-pdp-productLongDesc').toggleClass('jws-hidden');
    });

    $('#jws-pdp-showMore').on('click', function () {
        $('#jwsdw-pdp-productShortDesc').toggleClass('jws-hidden');
        $('#jwsdw-pdp-productLongDesc').toggleClass('jws-hidden');
    });

    $('[data-show-product-details]').on('click', function () {
        $(this).find('.jws-product-information').toggleClass('jws-hidden');
        $(this).find('.jws-show-less').toggleClass('jws-hidden');
        $(this)
            .parent()
            .find('.jws-product-details-info')
            .toggleClass('jws-hidden');
    });

    $('.jwsdw-pdp-mobileImageGallery').on('click', function () {
        setTimeout(function () {
            $('.jwsdw-pdp-zoomIcon-mobile').hide();
        }, 3000);
    });

    $('.jwsdw-pdp-imageViewer').on('click', function () {
        $('.jwsdw-pdp-zoomIcon-desktop').hide();
    });

    $('.jwsdw-pdp-imageViewer').on('touchstart', function () {
        $('.jwsdw-pdp-zoomIcon-mobile').hide();
    });

    $('.jws-accordionTab input[type=checkbox]').on('change', function () {
        var $this = $(this);

        if ($this.prop('checked')) {
            $this.attr('aria-expanded', 'true');
        } else {
            $this.attr('aria-expanded', 'false');
        }
    });

    // Open image viewer event
    $(document).on('click', '[data-image-zoom]', initImageViewer);

    // Open guide event
    $('[data-open-guide]').on('click', function (e) {
        e.preventDefault();
        const $productData = $('.product-data');
        const variationAttributes = $productData.data('productVariationAttributes');
        const pickerName = $(this).data('openGuide');

        const availableSizes = variationAttributes.filter(function (attr) {
            return attr.id === 'size';
        }).map(function (attr) {
            const availableSizeArray = [];
            Object.values(attr.values).forEach(function (valuesArray) {
                valuesArray.forEach(function (value) {
                    if (value.selectable) {
                        availableSizeArray.push(value.id.replace('B', ''));
                    }
                });
            });
            return availableSizeArray;
        }).flat();

        window.jwsdwMediator.publish('openPicker', pickerName, {
            gender: window.jwsdwSizeGuide.gender,
            type: window.jwsdwSizeGuide.type,
            level: 1,
            availableSizes: availableSizes
        });
    });

    // Notify me event
    $('[data-open-notify-me]').on('click', openNotifyMePicker);

    // Wishlist event
    $('.jwsdw-pdp-button-whishlist').on('click', function () {
        const jwsdwSettings = window.jwsdwSettings;
        $(this).prop('disabled', true);
        const isInWishlist = $(this).data('isInWishlist');

        if (!isInWishlist) {
            if (
                !jwsdwSettings.customerAuthenticated &&
                jwsdwSettings.wishlist.count ===
                jwsdwSettings.maxWishlistItemsForGuest
            ) {
                window.jwsdwMediator.publish('openPicker', 'loginPicker', {
                    callback: function () {
                        addToWishlist($(this));
                    }
                });
                $(this).prop('disabled', false);
                return;
            }

            addToWishlist($(this));
            return;
        }

        removeFromWishlist($(this));
    });

    $('#buy-now-online').on('click', function () {
        checkIfSizeSelected();
    });

    // Add to cart event
    $('.jwsdw-pdp-addToCartButton').on('click', function () {
        const hasSizeSelected = checkIfSizeSelected();
        if (hasSizeSelected) {
            addToCart($(this));
        }
    });

    // Giftcard swatch selection
    $('.jwsdw-product-swatch-giftcard').on('click', function () {
        const $giftcardSwatchesWrapper = $('.jwsdw-giftcard-amount-wrapper');
        $('.no-size-selected-warning').addClass('jws-hidden');
        $giftcardSwatchesWrapper
            .find('.jwsdw-product-swatch-giftcard.jwsdw-product-swatch-active')
            .removeClass('jwsdw-product-swatch-active')
            .addClass('jwsdw-product-swatch-selectable');
        $(this)
            .addClass('jwsdw-product-swatch-active')
            .removeClass('jwsdw-product-swatch-selectable');

        $('.jws-giftcard-pricing span').text($(this).data('giftcardPriceFormatted'));
        $('#jwsdw-giftcardAmount').val($(this).data('giftcardPrice'));
        $('.product-data').data('selectedPrice', $(this).data('giftcardPrice'));
        $('.jwsdw-pdp-cartButton').prop('disabled', false);

        $giftcardSwatchesWrapper
            .find('.jwsdw-add-giftcard-amount')
            .removeClass('jws-hidden');
        $giftcardSwatchesWrapper
            .find('.jwsdw-edit-giftcard-amount')
            .addClass('jws-hidden');

        const $stickyCartButtonLabel = $('#jwsdw-stickyAddToCart .jwsdw-pdp-addToCartButton .jwsdw-pdp-cartButtonLabel');
        $stickyCartButtonLabel.text($stickyCartButtonLabel.data('addToCartTitle'));
    });

    // Open giftcard amount editor
    $('[data-giftcard-picker-open]').on('click', function () {
        $('.no-size-selected-warning').addClass('jws-hidden');
        window.jwsdwMediator.publish('openPicker', 'giftcardAmountPicker', {
            isVisible: true
        });
    });

    // Giftcard custom amount selection
    $(document).on('click', '[data-giftcard-set-custom-amount]', function () {
        const $giftcardSwatchesWrapper = $('.jwsdw-giftcard-amount-wrapper');
        const $customAmountFormWrapper = $(this).parent();
        const $customAmountForm = $customAmountFormWrapper.find('form');
        const $customAmountInput = $customAmountFormWrapper.find('input#giftcardInput');

        $customAmountForm.validate({
            rules: {
                giftcardInput: {
                    required: true,
                    number: true,
                    min: 10,
                    max: 250
                }
            },
            messages: {
                giftcardInput: {
                    required: $customAmountInput.data('pricingError'),
                    min: $customAmountInput.data('pricingError'),
                    max: $customAmountInput.data('pricingError')
                }
            }
        });

        if (!$customAmountForm.valid()) {
            return;
        }

        window.jwsdwMediator.publish('closePicker', 'giftcardAmountPicker', true);

        const customAmount = $customAmountInput.val();
        const $amountSwatch = $giftcardSwatchesWrapper.find(
            `.jwsdw-product-swatch[data-giftcard-price="${customAmount}"]`
        );

        if ($amountSwatch && $amountSwatch.length > 0) {
            $amountSwatch.trigger('click');
            return;
        }

        const $amountPickerButton = $giftcardSwatchesWrapper.find('.jwsdw-add-giftcard-amount');
        if ($amountPickerButton.length > 0) {
            $amountPickerButton.addClass('jws-hidden');
        }

        const $amountEditButton = $giftcardSwatchesWrapper.find('.jwsdw-edit-giftcard-amount');
        if ($amountEditButton.length > 0) {
            const formattedPrice = window.jwsdwUtil.formatPrice(Number(customAmount));
            $amountEditButton.find('span').text(formattedPrice);
            $('.jws-giftcard-pricing span').text(formattedPrice);

            $amountEditButton.removeClass('jws-hidden');
            $giftcardSwatchesWrapper
                .find('.jwsdw-product-swatch-giftcard.jwsdw-product-swatch-active')
                .removeClass('jwsdw-product-swatch-active')
                .addClass('jwsdw-product-swatch-selectable');
        }

        $('#jwsdw-giftcardAmount').val(customAmount);
        $('.product-data').data('selectedPrice', customAmount);
        $('.jwsdw-pdp-cartButton').prop('disabled', false);
        const $stickyCartButtonLabel = $('#jwsdw-stickyAddToCart .jwsdw-pdp-addToCartButton .jwsdw-pdp-cartButtonLabel');
        $stickyCartButtonLabel.text($stickyCartButtonLabel.data('addToCartTitle'));
    });

    $(document).on('keydown', '.jwsdw-product-swatch', function(e) {
        var $this = $(this);
        var pdpSwatches = $this.closest('.jwsdw-product-swatchSelection');
        var firstSwatch = pdpSwatches.find('.jwsdw-product-swatch').first();
        var lastSwatch = pdpSwatches.find('.jwsdw-product-swatch').last();

        switch (e.key) {
            case 'ArrowLeft':
                $this.is(firstSwatch) ? lastSwatch.focus() : $this.prev().focus();
                break;
            case 'ArrowRight':
                $this.is(lastSwatch) ? firstSwatch.focus() : $this.next().focus();
                break;
            default:
                break;
        }
    });

    // Switch variant event
    $(document).on('click', '[data-select-variation]', handleVariationChange);

    // Open store availability picker
    $(document).on('click', '.jwsdw-pdp-button-availability', openStoreAvailabilityPicker);

    /**
     * Check if the user has selected a size
     * @returns {void}
     */
    function checkIfSizeSelected() {
        const $productData = $('.product-data');
        const selectedVariation = $productData.data('isGiftcard') ? $productData.data('selectedPrice') : $productData.data('selectedSize');
        const isOneSizeProduct = $productData.data('productVariationAttributes').find((attr) => attr.id === 'size').displayValue.toLowerCase() === 'one size';
        if (!selectedVariation && !isOneSizeProduct) {
            const observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) {
                        $('.jwsdw-pdp-productTitle')[0].scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }

                    observer.unobserve(entry.target);
                });
            });

            if ($('.no-size-selected-warning').length > 0) {
                observer.observe($('.no-size-selected-warning')[0], {
                    rootMargin: '60px',
                    threshold: 1.0
                });
                $('.no-size-selected-warning').removeClass('jws-hidden');
            }

            return false;
        }

        return true;
    }
    /**
     * Initialize the availability update for the product
     * @returns {void}
     */
    function initAvailabilityUpdate() {
        if (window.UNCACHED_DATA && window.UNCACHED_DATA.AVAILABILITY) {
            updateProductData(null, window.UNCACHED_DATA.AVAILABILITY.variationAttributes);
            updateColorVariationLinks(window.UNCACHED_DATA.AVAILABILITY.variationAttributes.find((attr) => attr.id === 'color'));
            updateAvailability(window.UNCACHED_DATA.AVAILABILITY.variationAttributes.find((attr) => attr.id === 'size'));
        } else {
            window.addEventListener('uncachedDataLoaded-availability', function () {
                updateProductData(null, window.UNCACHED_DATA.AVAILABILITY.variationAttributes);
                updateColorVariationLinks(window.UNCACHED_DATA.AVAILABILITY.variationAttributes.find((attr) => attr.id === 'color'));
                updateAvailability(window.UNCACHED_DATA.AVAILABILITY.variationAttributes.find((attr) => attr.id === 'size'));
            });
        }
    }

    /**
     * Initialize the promotions update for the product
     * @returns {void}
     */
    function initPromotionsUpdate() {
        if (window.UNCACHED_DATA && window.UNCACHED_DATA.PROMOTIONS) {
            updateSelectedPromotions(window.UNCACHED_DATA.PROMOTIONS.promotions);
        } else {
            window.addEventListener('uncachedDataLoaded-promotions', function () {
                updateSelectedPromotions(window.UNCACHED_DATA.PROMOTIONS.promotions);
            });
        }
    }

    /**
     * Adds to wishlist the desired product
     * @param {jQuery} $wishlistButton - the wishlist button element
     * @returns {void}
     */
    function addToWishlist($wishlistButton) {
        $wishlistButton.prop('disabled', true);

        const $productData = $('.product-data');
        const productId = $productData.data('productId');
        const url = $wishlistButton.data('addToWishlistUrl');

        /* Preparing payload */
        const payload = {
            productId
        };
        payload[window.jwsdwSettings.csrfTokenName] =
            window.jwsdwSettings.csrfTokenValue;

        $.ajax({
            url,
            method: 'POST',
            data: payload,
            dataType: 'json',
            success: (data) => {
                window.jwsdwSettings.wishlist.products.push({
                    id: data.itemId,
                    pid: data.productId,
                    color: data.color
                });

                $wishlistButton.find('.not-wishlisted').addClass('jws-hidden');
                $wishlistButton.find('.wishlisted').removeClass('jws-hidden');
                $wishlistButton.data('isInWishlist', true);
                $wishlistButton.attr('aria-checked', true);

                window.jwsdwMediator.publish('setWishlistCount', data.items);
                window.jwsdwMediator.publish('updateWishlist', data.wishlist);
            },
            error: (error) => {
                if (error.code === 'MAXIMUM_WISHLIST_ITEMS_FOR_GUEST') {
                    window.jwsdwMediator.publish('openPicker', 'loginPicker', {
                        showMaxGuestWishlistMessage: true,
                        callback: () => {
                            addToWishlist($wishlistButton);
                        }
                    });
                } else {
                    // TO-DO error handling
                }
            },
            complete: () => {
                $wishlistButton.prop('disabled', false);
            }
        });
    }

    /**
     * Removes product from wishlist
     * @param {jQuery.element} $wishlistButton - the wishlist button element
     * @returns {void}
     */
    function removeFromWishlist($wishlistButton) {
        const wishlist = window.jwsdwSettings.wishlist;
        const pid = $wishlistButton.data('masterId').toString();
        const color = $wishlistButton.data('selectedColor').toString();
        const url = $wishlistButton.data('removeFromWishlistUrl');

        const itemIndex = wishlist.products.findIndex(
            (product) => product.pid === pid && product.color === color
        );

        /* Preparing payload */
        const payload = {
            productListId: wishlist.id,
            itemId: wishlist.products[itemIndex].id
        };
        payload[window.jwsdwSettings.csrfTokenName] =
            window.jwsdwSettings.csrfTokenValue;

        $.ajax({
            url,
            method: 'POST',
            data: payload,
            dataType: 'json',
            success: (data) => {
                wishlist.products.splice(itemIndex, 1);

                $wishlistButton.find('.wishlisted').addClass('jws-hidden');
                $wishlistButton
                    .find('.not-wishlisted')
                    .removeClass('jws-hidden');
                $wishlistButton.data('isInWishlist', false);
                $wishlistButton.attr('aria-checked', false);

                window.jwsdwMediator.publish('setWishlistCount', data.items);
            },
            error: () => {
                // TO-DO error handling
            },
            complete: () => {
                $wishlistButton.prop('disabled', false);
            }
        });
    }

    /**
     * Adds product to cart
     * @param {jQuery.element} $cartButton - the cart button element
     * @returns {void}
     */
    function addToCart($cartButton) {
        $cartButton.spinner().start();
        $cartButton.addClass('jwsdw-progressButton');
        const url = $cartButton.data('addToCartUrl');
        const $productData = $('.product-data');
        const productId = $productData.data('productId');
        const isGiftcard = $productData.data('isGiftcard');

        const payload = {
            productId
        };

        const productToAdd = {
            id: productId,
            name: $productData.data('productName'),
            price: $productData.data('selectedPrice'),
            isBonusProduct: false
        };

        if (isGiftcard) {
            payload.price = $productData.data('selectedPrice');
        }

        let productData = {
            products: [productToAdd],
            level: 1
        };

        payload[window.jwsdwSettings.csrfTokenName] =
            window.jwsdwSettings.csrfTokenValue;

        window.jwsdwMediator.publish(
            'openPicker',
            'cartPicker',
            productData
        );

        $.ajax({
            url,
            method: 'POST',
            data: payload,
            dataType: 'json',
            success: (data) => {
                productData = Object.assign(productData, data);

                productData.addToCartSuccessful = true;
                window.jwsdwMediator.publish(
                    'updatePicker',
                    'cartPicker',
                    productData
                );
                window.jwsdwMediator.publish(
                    'updatePicker',
                    'expressCheckoutPicker',
                    productData
                );
                window.jwsdwMediator.publish(
                    'setCartCount',
                    productData.totalItems
                );
            },
            error: () => {
                // TO-DO error handling
            },
            complete: () => {
                $cartButton.spinner().stop();
                $cartButton.removeClass('jwsdw-progressButton');
            }
        });
    }

    /**
     * Initialize image gallery swiper
     * @returns {void}
     */
    function initImageGallerySwiper() {
        const gallerySwiper = new Swiper('#jwsdw-pdp-mobileImageSwiper', {// eslint-disable-line no-unused-vars
            slidesPerView: 1,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            on: {
                slideChange: function (swiper) {
                    updatePagination(
                        $('#jwsdw-pdp-mobileImageSwiper'),
                        swiper.activeIndex
                    );
                }
            }
        });
    }

    /**
     * Init the sticky add to cart button observer
     * @returns {void}
     */
    function initStickyCTAs() {
        const pdpCTAsContainer = document.querySelector('#jwsdw-pdp-ctas');
        const $stickyCTAsContainer = $('#jwsdw-stickyAddToCart');

        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0
        };

        const observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                    $stickyCTAsContainer.removeClass('jws-hidden');
                } else {
                    $stickyCTAsContainer.addClass('jws-hidden');
                }
            });
        }, options);

        observer.observe(pdpCTAsContainer);
    }

    /**
     * Open zoom image viewer
     * @param {event} e - the current event
     * @returns {void}
     */
    function initImageViewer() {
        $('body').addClass('jws-overflowYHidden');
        const $imageViewContainer = $('[data-jwsdw-image-viewer]');
        const slideId = $(this).data('slideId');
        const $imageViewTemplate = $('#imageViewer').html();

        $imageViewContainer.html($imageViewTemplate);
        const $thumbnailContainer = $('#jwsdw-productThumbsSlider .swiper-wrapper');
        const $mainSliderContainer = $('#jwsdw-productImageSlider .swiper-wrapper');
        const selectedColor = $('.product-data').data('selectedColor');
        const storedMedia = $('.product-media').data('productMedia');
        const colorImages = storedMedia[selectedColor] ? storedMedia[selectedColor].images : [];
        const imagesToProcess = colorImages.full;
        const thumbnailImages = imagesToProcess.thumbGallery || colorImages.full;

        imagesToProcess.forEach((image, index) => {
            const $mainImage = $($('#imageViewerImageTemplate').html());

            // General image props
            processImageProps($mainImage, image, index);

            $mainImage.find('.jwsdw-imageContainer').prop('id', `jwsdw-imageContainer-${index}`);
            $mainImage.find('img').prop('id', `${index}-imageViewer`);

            $mainSliderContainer.append($mainImage);
            window.jwsdwApi.pinch.initPinch(index);
        });

        thumbnailImages.forEach((image, index) => {
            const $thumbnail = $($('#thumbnailImageTemplate').html());

            processImageProps($thumbnail, image, index);

            // Custom image viewer props
            $thumbnail.find('img').prop('id', `${index}-imageViewer`);
            $thumbnail.attr('data-slide-id', index); // unfortunately we need to use attr here to alter the actual attribute on the element for the swiper to work as expected

            $thumbnailContainer.append($thumbnail);
        });

        // eslint-disable-next-line no-unused-vars
        const thumbSwiper = new Swiper('#jwsdw-productThumbsSlider', {
            slidesPerView: 'auto',
            initialSlide: slideId,
            direction: 'vertical',
            on: {
                init: function () {
                    $(
                        `#jwsdw-productThumbsSlider [data-slide-id=${slideId}]`
                    ).addClass('swiper-slide-thumb-active');
                }
            }
        });

        // eslint-disable-next-line no-unused-vars
        const mainSwiper = new Swiper('#jwsdw-productImageSlider', {
            slidesPerView: 1,
            initialSlide: slideId,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            on: {
                init: function (swiper) {
                    updatePagination(
                        $('#jwsdw-productImageSlider'),
                        swiper.activeIndex,
                        swiper.slides.length
                    );

                    if (window.matchMedia('(max-width: 900px)').matches) {
                        $('.jwsdw-pdp-zoomIcon-mobile').show();
                    } else {
                        $('.jwsdw-pdp-zoomIcon-desktop').show();
                    }

                    setTimeout(function () {
                        if (window.matchMedia('(max-width: 900px)').matches) {
                            $('.jwsdw-pdp-zoomIcon-mobile').hide();
                        } else {
                            $('.jwsdw-pdp-zoomIcon-desktop').hide();
                        }
                    }, 3000);
                },
                slideChange: function (swiper) {
                    // eslint-disable-line no-undef
                    updateActiveThumbsSlide(swiper.activeIndex);
                }
            }
        });

        initImageViewerEvents();
    }

    /**
     * Close image viewer
     * @returns {void}
     */
    function closeImageViewer() {
        $('body').removeClass('jws-overflowYHidden');
        $('[data-jwsdw-image-viewer]').html('');
    }

    /**
     * Initialize image viewer events
     * @returns {void}
     */
    function initImageViewerEvents() {
        $('[data-image-viewer-close]').on('click', closeImageViewer);

        $('#jwsdw-productThumbsSlider .swiper-slide').on('click', function () {
            const slideId = $(this).data('slideId');
            if (typeof slideId === 'number') {
                $('#jwsdw-productImageSlider')[0].swiper.slideTo(slideId);
            }
            updateActiveThumbsSlide(slideId);
        });
    }

    /**
     * Update active thumbs slide
     * @param {number} slideId - the slide id
     * @returns {void}
     */
    function updateActiveThumbsSlide(slideId) {
        $('#jwsdw-productThumbsSlider .swiper-slide-thumb-active').removeClass(
            'swiper-slide-thumb-active'
        );
        $(`#jwsdw-productThumbsSlider [data-slide-id=${slideId}]`).addClass(
            'swiper-slide-thumb-active'
        );
        updatePagination($('#jwsdw-productImageSlider'), slideId);
    }

    /**
     * Update the display pagination for the swiper
     * @param {jQuery} $container - swiper container
     * @param {number} currentIndex - current slide
     * @param {number} totalSlides - total number of slides
     * @returns {void}
     */
    function updatePagination($container, currentIndex, totalSlides) {
        const $paginationCurrent = $container.find(
            '.swiper-pagination-current'
        );
        const $paginationTotal = $container.find('.swiper-pagination-total');
        $paginationCurrent.text(currentIndex + 1);
        if (totalSlides && totalSlides !== $paginationTotal.text()) {
            $paginationTotal.text(totalSlides);
        }
    }

    /**
     * Handle the variation change
     * @param {event} e - the current event
     * @returns {void}
     */
    function handleVariationChange(e) {
        e.preventDefault();

        if ($(this).hasClass('jwsdw-product-swatch-active')) {
            return;
        }

        const sizeId = $(this).data('sizeId');
        const isColorChange = $(this).hasClass('jwsdw-product-color');
        const $cartButton = $('.jwsdw-pdp-addToCartButton');
        const $stickyCartButton = $('#jwsdw-stickyAddToCart .jwsdw-pdp-addToCartButton');
        const $notifyMe = $cartButton.siblings('.jwsdw-pdp-notifyMe');
        const $stickyNotifyMe = $stickyCartButton.siblings('.jwsdw-pdp-notifyMe');
        const $productData = $('.product-data');

        if (isColorChange) {
            $(this).addClass('jwsdw-product-color-active');
            $(this).siblings('.jwsdw-product-color-active').removeClass('jwsdw-product-color-active');
            handleProductImageChange($(this).data('colorId'));
        } else {
            $productData.data('selectedSize', sizeId);

            const $selectedSwatch = $(this).parents('.jwsdw-pdp-size').find('.jwsdw-product-swatch-active');
            $selectedSwatch
                .toggleClass('jwsdw-product-swatch-selectable', !$selectedSwatch.hasClass('jwsdw-not-in-stock'))
                .removeClass('jwsdw-product-swatch-active');

            $(this)
                .addClass('jwsdw-product-swatch-active')
                .removeClass('jwsdw-product-swatch-selectable');
        }

        const url = $(this).data('selectVariation');
        const availabilityUrl = $(this).data('availabilityUrl');
        const promotionsUrl = $(this).data('promotionsUrl');
        const seoUrl = $(this).data('href');

        $('.no-size-selected-warning').addClass('jws-hidden');

        if (!url) {
            $productData.data('selectedSize', '');
            $cartButton
                .addClass('jwsdw-pointerEvents-none jws-opacity-50')
                .prop('disabled', 'disabled');
            return;
        }

        $cartButton.addClass('jwsdw-progressButton');
        $cartButton.spinner().start();
        if ($notifyMe.length > 0) {
            $notifyMe.spinner().start();
        }

        if ($stickyNotifyMe.length > 0) {
            $stickyNotifyMe.spinner().start();
        }

        const variationCall = $.ajax({
            url,
            method: 'GET',
            dataType: 'json'
        });

        const promotionsCall = $.ajax({
            url: promotionsUrl,
            method: 'GET',
            dataType: 'json'
        });

        const availabilityCall = $.ajax({
            url: availabilityUrl,
            method: 'GET',
            dataType: 'json'
        });

        Promise.all([variationCall, promotionsCall, availabilityCall])
            .then((responses) => {
                const [variationData, promotionsData, availabilityData] = responses;

                if (variationData.meta) {
                    updateMetaData(variationData.meta);
                }

                const state = {};
                availabilityData.variationAttributes.forEach((attr) => {
                    state[attr.id] = attr.displayValue;
                });

                window.history.replaceState(state, '', seoUrl);
                updateProductData(variationData.product, availabilityData.variationAttributes);
                if (isColorChange) {
                    updateWishlistButton(variationData.product);
                    updateProductSuggestions(variationData.product.suggestions);
                }
                updateColorVariationLinks(availabilityData.variationAttributes.find((attr) => attr.id === 'color'));
                updateAvailability(availabilityData.variationAttributes.find((attr) => attr.id === 'size'));
                updatePrice(variationData.product.renderedPrice);
                updateProductDetailsInfo(variationData.product.id);
                updateProductFlags(variationData.product.activeFlags, variationData.product.cobrandingFlag);
                updateSelectedPromotions(promotionsData.promotions);

                const isOneSizeProduct = availabilityData.variationAttributes.find((attr) => attr.id === 'size').displayValue.toLowerCase() === 'one size';
                const hasSizeSelected = !!$productData.data('selectedSize') || isOneSizeProduct;
                // Update PDP CTAs
                $cartButton
                    .toggleClass('jwsdw-pointerEvents-none jws-opacity-50', hasSizeSelected && !availabilityData.available)
                    .prop('disabled', hasSizeSelected && !availabilityData.available ? 'disabled' : '');

                if ($notifyMe.length > 0) {
                    $cartButton.toggleClass('jws-hidden', hasSizeSelected && !availabilityData.available);
                    $notifyMe.toggleClass('jws-hidden', !hasSizeSelected || availabilityData.available);
                    $notifyMe.spinner().stop();
                }

                // Update sticky CTAs
                $stickyCartButton
                    .prop('disabled', !hasSizeSelected || !availabilityData.available ? 'disabled' : '');

                if ($stickyNotifyMe.length > 0) {
                    $stickyCartButton.toggleClass('jws-hidden', hasSizeSelected && !availabilityData.available);
                    $stickyCartButton.siblings('.jwsdw-pdp-notifyMe').toggleClass('jws-hidden', !hasSizeSelected || availabilityData.available);
                    $stickyNotifyMe.spinner().stop();
                }

                const $stickyCartButtonLabel = $stickyCartButton.find('.jwsdw-pdp-cartButtonLabel');
                $stickyCartButtonLabel.text(hasSizeSelected ?
                    $stickyCartButtonLabel.data('addToCartTitle') :
                    $stickyCartButtonLabel.data('selectSizeTitle'));

                if (hasSizeSelected && !availabilityData.available && $notifyMe.length > 0) {
                    openNotifyMePicker();
                }

                sendSwatchChangeEvent(variationData.product, availabilityData.availability.ats);
            })
            .catch((error) => {// eslint-disable-line no-unused-vars
                // TO-DO error handling
            })
            .finally(() => {
                $cartButton.removeClass('jwsdw-progressButton');
                $cartButton.spinner().stop();
                $('.jwsdw-product-swatch-active').siblings('.jwsdw-product-swatch').attr('tabindex', '-1');
                $('.jwsdw-product-swatch-active').attr('tabindex', '0').focus();
            });
    }

    /**
     * Update all the images for the new color id
     * @param {Object} colorId - the color id of the new variation
     * @returns {void}
     */
    function handleProductImageChange(colorId) {
        const storedMedia = $('.product-media').data('productMedia');
        const currentColorMedia = storedMedia[colorId];
        const imagesToProcess = currentColorMedia ? currentColorMedia.images : {};
        const fullImages = imagesToProcess.full || [];
        const largeImages = imagesToProcess.large || imagesToProcess.xlarge || imagesToProcess.full || [];
        const xlargeImages = imagesToProcess.xlarge || imagesToProcess.full || [];
        const mediumImages = imagesToProcess.medium || imagesToProcess.large || imagesToProcess.xlarge || imagesToProcess.full || [];
        const mobileImages = imagesToProcess.small || imagesToProcess.full || [];
        const videoToProcess = currentColorMedia ? currentColorMedia.video : null;

        if (!imagesToProcess && !videoToProcess) {
            return;
        }

        const $mobileImagesContainer = $('.jwsdw-pdp-mobileImageGallery .swiper-wrapper');
        const $desktopImagesContainer = $('.jwsdw-pdp-desktopImageGallery');
        let index = 0;

        $mobileImagesContainer.html('');
        $desktopImagesContainer.html('');

        fullImages.forEach(function (image, imageIndex) {
            if (videoToProcess && ((videoToProcess.sortOrder && videoToProcess.sortOrder === index) || (!videoToProcess.sortOrder && index === 0))) {
                // Update video template
                if (videoToProcess.source && videoToProcess.source.toLowerCase() === 'youtube') {
                    const $desktopYoutubeVideoContainer = $($('#desktopYoutubeVideoTemplate').html());
                    $desktopYoutubeVideoContainer.addClass(fullImages.length === 0 ? 'jws-grid-large-column-12 jws-bgColorBone5' : 'jws-grid-large-column-6');
                    $desktopYoutubeVideoContainer.find('.jwsdw-pdp-mediaItem').data('slideId', index);
                    updateYoutubeVideo($desktopYoutubeVideoContainer, videoToProcess);

                    $desktopImagesContainer.append($desktopYoutubeVideoContainer);
                } else {
                    const $desktopVideoContainer = $($('#desktopVideoTemplate').html());
                    $desktopVideoContainer.addClass(fullImages.length === 0 ? 'jws-grid-large-column-12 jws-bgColorBone5' : 'jws-grid-large-column-6');
                    $desktopVideoContainer.find('.jwsdw-pdp-mediaItem').data('slideId', index);
                    updateDefaultVideo($desktopVideoContainer, videoToProcess);

                    $desktopImagesContainer.append($desktopVideoContainer);
                }

                index++;
            }

            const responsiveImagesObject = {
                medium: mediumImages[imageIndex],
                large: largeImages[imageIndex],
                xlarge: xlargeImages[imageIndex]
            };

            const $imageDesktopContainer = $($('#mediaDesktopImage').html());
            $imageDesktopContainer.addClass(fullImages.length === 1 && !videoToProcess ? 'jws-grid-large-column-12 jws-bgColorBone5' : 'jws-grid-large-column-6');
            $imageDesktopContainer.find('.jwsdw-pdp-mediaItem').toggleClass('jwsdw-pdp-single-mediaItem', fullImages.length === 1);

            processImageProps($imageDesktopContainer.find('.jwsdw-pdp-mediaItem'), image, index, responsiveImagesObject);

            if ($('.product-data').data('hasCobrandingFlag') && imageIndex === 0) {
                const $cobrandingFlag = $($('#coBrandingProductFlagTemplate').html());
                $imageDesktopContainer.find('.jwsdw-picture').prepend($cobrandingFlag);
            }

            $desktopImagesContainer.append($imageDesktopContainer);

            index++;
        });

        index = 0;

        mobileImages.forEach(function (image, imageIndex) {
            if (videoToProcess && ((videoToProcess.sortOrder && videoToProcess.sortOrder === index) || (!videoToProcess.sortOrder && index === 0))) {
                // Update video template
                if (videoToProcess.source && videoToProcess.source.toLowerCase() === 'youtube') {
                    const $mobileYoutubeVideoContainer = $($('#mobileYoutubeVideoTemplate').html());

                    $mobileYoutubeVideoContainer.data('slideId', index);
                    updateYoutubeVideo($mobileYoutubeVideoContainer, videoToProcess);

                    $mobileImagesContainer.append($mobileYoutubeVideoContainer);
                } else {
                    const $mobileVideoContainer = $($('#mobileVideoTemplate').html());

                    $mobileVideoContainer.data('slideId', index);
                    updateDefaultVideo($mobileVideoContainer, videoToProcess);

                    $mobileImagesContainer.append($mobileVideoContainer);
                }

                index++;
            }

            const $imageMobileContainer = $($('#mediaMobileImage').html());
            processImageProps($imageMobileContainer, image, index);

            if ($('.product-data').data('hasCobrandingFlag') && imageIndex === 0) {
                const $cobrandingFlag = $($('#coBrandingProductFlagTemplate').html());
                $imageMobileContainer.find('.jwsdw-picture').prepend($cobrandingFlag);
            }

            $mobileImagesContainer.append($imageMobileContainer);

            index++;
        });

    }

    /**
     * Update the image props for the new image
     * @param {jQuery.element} $imageContainer - the image container for which to update the props
     * @param {Object} image - image object
     * @param {number} index - the index of the image
     * @param {Object} responsiveImagesObject - images object for medium, large and xlarge viewports
     * @returns {void}
     */
    function processImageProps($imageContainer, image, index, responsiveImagesObject) {
        $imageContainer.data('slideId', index);
        if (responsiveImagesObject) {
            Object.entries(responsiveImagesObject).forEach(([viewport, responsiveImage]) => {
                const $source = $imageContainer.find(`source[data-viewport="${viewport}"]`);
                if ($source.length > 0) {
                    $source.attr('srcset', responsiveImage ? responsiveImage.url : image.url);
                }
            });
        }
        $imageContainer.find('img').prop('alt', image.alt).prop('src', image.url);
    }

    /**
     * @param {Object} size - new variant product size
     * @returns {void}
     */
    function updateAvailability(size) {
        if (!size) {
            return;
        }

        const $sizeContainer = $('.jwsdw-pdp-size');
        const $sizeTypesContainer = $sizeContainer.find('[data-size-type]');
        const $productData = $('.product-data');

        $sizeTypesContainer.each(function () {
            const $that = $(this);
            const sizeType = $(this).data('sizeType');
            $(this).html('');
            if (size.values[sizeType].length > 0) {
                size.values[sizeType].forEach((sizeValue, index) => {
                    const $linkTag = $($('#sizeSwatch').html());
                    const $swatchName = $linkTag.find('.swatch-name');
                    const $swatchUnavailableIcon = $linkTag.find('.swatch-unavailable-icon');
                    $linkTag
                        .addClass(!sizeValue.selectable ? 'jwsdw-not-in-stock jwsdw-product-swatch-disabled' : '')
                        .addClass(sizeValue.selected && $productData.data('selectedSize') === sizeValue.id ?
                            'jwsdw-product-swatch-active' :
                            sizeValue.selectable ?
                                'jwsdw-product-swatch-selectable' :
                                '')
                        .attr({
                            'aria-checked': sizeValue.selected,
                            'aria-label': sizeValue.displayValue,
                            'aria-describedby': `size-${size.id}-description`,
                            'aria-disabled': !sizeValue.selectable,
                            'tabindex': index === 0 ? '0' : '-1'
                        })
                        .data({
                            selectVariation: sizeValue.url,
                            sizeId: sizeValue.id,
                            availabilityUrl: sizeValue.availabilityUrl,
                            promotionsUrl: sizeValue.promotionsUrl,
                            href: sizeValue.seoUrl
                        });
                    $swatchName.text(sizeValue.displayValue);
                    $swatchUnavailableIcon.addClass(!sizeValue.selectable && $productData.data('notifyMeEnabled') ? '' : 'jws-hidden');
                    $that.append($linkTag);
                });
            }
        });
    }

    /**
     * Update the color variations from PDP
     * @param {Object} color - the color variation attribute to update
     * @returns {void}
     */
    function updateColorVariationLinks(color) {
        if (!color) {
            return;
        }

        const $colorContainer = $('.jwsdw-pdp-color-container');
        $colorContainer.html('');

        color.values.forEach((colorValue) => {
            const $linkTag = $($('#colorSwatch').html());
            $linkTag
                .attr({
                    'aria-checked': colorValue.selected,
                    'aria-label': colorValue.displayValue,
                    'aria-describedby': `color-${color.id}-description`
                })
                .data({
                    selectVariation: colorValue.url,
                    colorId: colorValue.id,
                    availabilityUrl: colorValue.availabilityUrl,
                    promotionsUrl: colorValue.promotionsUrl,
                    href: colorValue.seoUrl
                });

            if (colorValue.selected) {
                $linkTag
                    .addClass('jwsdw-product-color-active');
                $('.jwsdw-pdp-selected-color').text(colorValue.displayValue);
            }

            $linkTag.css({ 'background-color': colorValue.rgb, 'border-color': colorValue.rgb });

            $colorContainer.append($linkTag);
        });
    }

    /**
     * Update global product data
     * @param {Object} product - new variant product data
     * @param {Object} variationAttributes - the availability information for the variation attributes
     * @returns {void}
     */
    function updateProductData(product, variationAttributes) {
        const $productData = $('.product-data');
        if (product) {
            $productData.data({
                productId: product.id,
                productName: product.productName,
                selectedPrice: product.price.sales.value
            });
        }

        if (variationAttributes) {
            $productData.data('productVariationAttributes', variationAttributes);
            variationAttributes.forEach((attr) => {
                if (attr.id === 'color') {
                    const $productMedia = $('.product-media');
                    const storedMedia = $productMedia.data('productMedia');
                    const selectedColorId = attr.values.find((value) => value.selected).id;
                    const storedMediaForSelectedColor = storedMedia[selectedColorId];
                    const selectedColor = attr.values.find((value) => value.selected);

                    $productData.data({
                        selectedColor: selectedColor.id,
                        selectedColorName: selectedColor.displayValue,
                        productFirstImageUrl: storedMediaForSelectedColor ? storedMediaForSelectedColor.images.full[0].url : ''
                    });
                } else if (attr.id === 'size') {
                    const flatenSizeValues = Object.values(attr.values).map((value) => value).flat();
                    let selectedSize = null;

                    if ($productData.data('selectedSize')) {
                        selectedSize = flatenSizeValues.find((value) => value.selected && value.id === $productData.data('selectedSize'));
                    } else if (flatenSizeValues.length === 1) {
                        selectedSize = flatenSizeValues[0];
                    }

                    $productData.data('selectedSize', (selectedSize && selectedSize.id) || '');
                }
            });
        }
    }

    /**
     * Update wishlist button
     * @param {Object} product - product data
     * @returns {void}
     */
    function updateWishlistButton(product) {
        const $productData = $('.product-data');
        const $wishlistButton = $('.jwsdw-pdp-button-whishlist');
        $wishlistButton.data({
            isInWishlist: product.isInWishlist,
            selectedColor: $productData.data('selectedColor')
        });
        $wishlistButton.find('.wishlisted').toggleClass('jws-hidden', !product.isInWishlist);
        $wishlistButton.find('.not-wishlisted').toggleClass('jws-hidden', product.isInWishlist);
        $wishlistButton.attr('aria-checked', product.isInWishlist);
    }

    /**
     * Update price template
     * @param {html} renderedPrice - the rendered html of the product price
     * @returns {void}
     */
    function updatePrice(renderedPrice) {
        $('.jwsdw-product-pricing').html(renderedPrice);
    }

    /**
     * Update the id displayed in the product details info accordion
     * @param {string} productId - the new product id
     * @returns {void}
     */
    function updateProductDetailsInfo(productId) {
        $('#productDetail-description')
            .parent()
            .find('[data-product-id]')
            .text(`#${productId}`)
            .data('productId', productId);
    }

    /**
     * Update the flags displayed on top of product details
     * @param {Array} activeFlags - the active flags
     * @returns {void}
     */
    function updateProductFlags(activeFlags) {
        const $flagsContainer = $('.jwsdw-productFlags-pdp-wrapper');
        $flagsContainer.html('');

        if (!activeFlags || activeFlags.length === 0) {
            return;
        }

        activeFlags.forEach((activeFlag) => {
            const $flag = $($('#productFlag').html());
            $flag.addClass(`jwsdw-productFlag-${activeFlag.value}`);

            switch (activeFlag.type) {
                case 'sale':
                    $flag.addClass('jws-bgColorRed');
                    break;
                case 'promotion':
                    $flag.addClass('jws-bgColorBlack');
                    break;
                default:
                    $flag.addClass('jws-bgColorBone1');
                    break;
            }

            $flag.text(activeFlag.message);
            $flagsContainer.append($flag);
        });
    }

    /**
     * @param {Object} $videoContainer - video container
     * @param {Object} video - video data
     * @returns {void}
     */
    function updateDefaultVideo($videoContainer, video) {
        const sourcePath = $videoContainer.find('.jwsdw-pdp-productVideo').data('sourcePath');
        const params = {
            pid: $('.product-data').data('productId'),
            videoPath: video.name
        };

        const videoUrl = window.jwsdwUtil.urlUtils.appendParamsToUrl(sourcePath, params);
        $videoContainer.find('source').prop('src', videoUrl);
    }

    /**
     * @param {Object} $videoContainer - video container
     * @param {Object} video - video data
     * @returns {void}
     */
    function updateYoutubeVideo($videoContainer, video) {
        const $videoWrapper = $videoContainer.find('.jwsdw-youtube-player');
        $videoWrapper
            .prop('id', video.id)
            .data({
                videoId: video.id || '',
                videoIdM: video.idM || '',
                videoIdL: video.idL || '',
                videoAutoplay: video.playerVars.autoplay || 0,
                videoControls: video.playerVars.controls || 0,
                videoShowinfo: video.playerVars.showinfo || 0,
                videoModestbranding: video.playerVars.modestbranding || 0,
                videoLoop: video.playerVars.loop || 0,
                alt: video.headline || ''
            });
    }

    /**
     * Update promotions section
     * @param {Array} promotions - the promotions to update
     * @returns {void}
     */
    function updateSelectedPromotions(promotions) {
        const $promotionsBlock = $('#promotionsBlock');

        if (!promotions || promotions.length === 0) {
            $promotionsBlock.html('');
            return;
        }

        const selectedPromotion = promotions[0];

        if ($promotionsBlock.data('promotionId') === selectedPromotion.promotionId) {
            return;
        }

        if (selectedPromotion) {
            if (selectedPromotion.isSpecialPromotion && !selectedPromotion.isBonusPromotion) {
                const $promotionTemplate = $($('#specialPromotionTemplate').html());
                $promotionTemplate.find('img').attr('data-src', selectedPromotion.iconPath).prop('alt', selectedPromotion.promotionName);

                const $promotionName = $promotionTemplate.find('h3');
                const $calloutWrapper = $promotionTemplate.find('.jwsdw-pdp-specialPromoBanner-text-wrapper');
                const $promotionContentPicker = $promotionTemplate.find('.jwsdw-promotion-content-picker');

                if (selectedPromotion.promotionName) {
                    $promotionName.text(selectedPromotion.promotionName);
                    $promotionName.removeClass('jws-hidden');
                }

                if (selectedPromotion.specialCalloutMessage) {
                    $calloutWrapper.html(selectedPromotion.specialCalloutMessage);
                    $calloutWrapper.removeClass('jws-hidden');
                }

                if (selectedPromotion.contentId) {
                    $promotionContentPicker.attr('data-picker-options', JSON.stringify({ cid: selectedPromotion.contentId, width: 1, level: 1 }));
                    $promotionContentPicker.removeClass('jws-hidden');
                }

                $promotionsBlock.html($promotionTemplate);
            } else if (selectedPromotion.isBonusPromotion && selectedPromotion.firstBonusProductId) {
                const $promotionTemplate = $($('#bonusPromotionTemplate').html());
                $promotionTemplate
                    .find('img')
                    .attr('data-src', selectedPromotion.productImage)
                    .attr('data-srcset', `${selectedPromotion.productImageRetina} 2x`)
                    .prop('alt', selectedPromotion.defaultSelectableBonusProduct.name);

                const $calloutWrapper = $promotionTemplate.find('.jwsdw-pdp-bonusPromoBanner-text-wrapper');
                const $promotionContentPicker = $promotionTemplate.find('.jwsdw-promotion-info-picker');

                if (selectedPromotion.calloutMsg) {
                    $calloutWrapper.html(selectedPromotion.calloutMsg);
                    $calloutWrapper.removeClass('jws-hidden');
                }

                if (selectedPromotion.promoInfoPicker) {
                    $promotionContentPicker.attr('data-picker-options', JSON.stringify({ cid: selectedPromotion.promoInfoPicker, width: 1, level: 1 }));
                    $promotionContentPicker.removeClass('jws-hidden');
                }

                $promotionsBlock.html($promotionTemplate);
            } else {
                const $promotionTemplate = $($('#defaultPromotionTemplate').html());
                const $promotionName = $promotionTemplate.find('.jwsdw-default-promotion-name');
                const $calloutWrapper = $promotionTemplate.find('.callout-message-container');

                if (selectedPromotion.promotionName) {
                    $promotionName.text(selectedPromotion.promotionName);
                    $promotionName.removeClass('jws-hidden');
                }

                if (selectedPromotion.detailsPDP) {
                    $calloutWrapper.html(selectedPromotion.calloutMsg);
                    $calloutWrapper.removeClass('jws-hidden');
                }

                $promotionsBlock.html($promotionTemplate);
            }
        }
    }

    /**
     * Update the product suggestions section
     * @param {HTMLElement} suggestions - the rendered suggestions to update
     * @returns {void}
     */
    function updateProductSuggestions(suggestions) {
        const $productSuggestionsContainer = $('#productSuggestions');
        $productSuggestionsContainer.html('').append(suggestions);

        if ($productSuggestionsContainer.find('#pdp-completeOutfit').length > 0) {
            const $productSwiperContainer = $productSuggestionsContainer.find('.jwsdw-cm-completeOutfit-swiper.swiper-container');
            const idx = 1;
            const options = window.jwsdwApi.slider.options.productSliderModule;
            options.loop = false;
            options.pagination = {
                'el': ".swiper-pagination-" + idx,
                'clickable': true,
                'renderBullet': function (index, className) {
                    return '<span class="' + className + '"></span>';
                }
            };
            if ($productSwiperContainer.find('.jwsdw-cm-productSliderModule-slide').length) {
                window.jwsdwApi.slider.initSwiper(
                    '#' + $productSwiperContainer.attr('id'),
                    options
                );
            }
        }
    }

    /**
     * Send swatch change event
     * @param {Object} product - the product data
     * @param {Number} ats - available to sell param
     * @returns {void}
     */
    function sendSwatchChangeEvent(product, ats) {
        const $productData = $('.product-data');
        // send swatch changes to the tag manager
        window.jwsdwApi.tracking.fireEvent('swatchChange', {
            type: 'swatchChange',
            productname: product.productName,
            productid: product.id,
            productPriceWithoutVAT: product.price.sales.value,
            productStatus: 'view',
            productColorName: $productData.data('selectedColorName'),
            productSizeName: $productData.data('selectedSize'),
            availableProducts: ats
        });

        // publish event for storeAvailabilityPicker
        window.jwsdwMediator.publish('changeProductId', product.id);
    }

    /**
     * Open notify me picker
     * @returns {void}
     */
    function openNotifyMePicker() {
        const $productData = $('.product-data');
        const isOneSizeProduct = $productData.data('productVariationAttributes').find((attr) => attr.id === 'size').displayValue.toLowerCase() === 'one size';
        const selectedSize = isOneSizeProduct ? 'One Size' : $productData.data('selectedSize');

        if (!selectedSize) {
            $('.no-size-selected-warning').removeClass('jws-hidden');
            return;
        }

        const selectedColor = $productData.data('selectedColor');
        const productID = $productData.data('productId');
        const productName = $productData.data('productName');
        const iamgeUrl = $productData.data('productFirstImageUrl');

        window.jwsdwMediator.publish('openPicker', 'notifyMePicker', {
            width: 1,
            productID,
            productName,
            productSize: selectedSize,
            productColor: selectedColor,
            image: iamgeUrl,
            isVisible: true,
            level: 2
        });

        // Script Notify Me Button Click (open)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'ce.misc',
            'eventCategory': 'MISC',
            'eventAction': 'Notify Me',
            'eventLabel': 'open',
            'eventValue': undefined,
            'nonInteraction': false,
            'selection': undefined
        });
    }

    /**
     * Open store availability picker
     * @returns {void}
     */
    function openStoreAvailabilityPicker() {
        const $productData = $('.product-data');

        if (!$productData.data('selectedSize')) {
            $('.no-size-selected-warning').removeClass('jws-hidden');
            return;
        }

        window.jwsdwMediator.publish('openPicker', 'storeAvailabilityListPicker', {
            productId: $productData.data('productId'),
            // TO-DO consider replacing angular store availability picker with jQuery controlled one
            variants: null // this will trigger angular to fetch for the variants and filter them as necessary for the picker
        }, true);

        window.jwsdwApi.tracking.fireEvent('openAvailabilityDialog', {
            type: 'openAvailabilityDialog'
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'ce.misc',
            eventCategory: 'MISC',
            eventAction: 'Product Availability',
            eventLabel: 'open',
            eventValue: undefined,
            nonInteraction: false,
            selection: undefined
        });
    }

    /**
     * Update meta data
     * @param {Object} metaData - the meta data to update
     * @returns {void}
     */
    function updateMetaData(metaData) {
        if (metaData.pageTitle) {
            document.title = window.jwsdwUtil.uiUtils.decodeHTMLEntities(metaData.pageTitle);
        }

        let descriptionMeta = document.querySelector('meta[name="description"]');
        if (metaData.pageDescription) {
            if (!descriptionMeta) {
                descriptionMeta = document.createElement('meta');
                descriptionMeta.name = 'description';
                document.head.appendChild(descriptionMeta);
            }

            descriptionMeta.content = window.jwsdwUtil.uiUtils.decodeHTMLEntities(metaData.pageDescription);
        }

        if (metaData.pageKeywords) {
            let keywordsMeta = document.querySelector('meta[name="keywords"]');
            if (!keywordsMeta) {
                keywordsMeta = document.createElement('meta');
                keywordsMeta.name = 'keywords';
                document.head.appendChild(keywordsMeta);
            }
            keywordsMeta.content = window.jwsdwUtil.uiUtils.decodeHTMLEntities(metaData.pageKeywords);
        }
    }

    /**
     * Initialize the SAIZ tool listener
     * @returns {void}
     */
    function initSaizToolListener() {
        $(window).on('jw-saiz-customer', function (e) { // eslint-disable-line no-unused-vars
            const isSaizCustomer = localStorage.getItem('isSaizCustomer');
            if (isSaizCustomer && isSaizCustomer === 'true') {
                return;
            }

            if (e.detail && e.detail.measuredSize) {
                const payload = e.detail;
                payload[window.jwsdwSettings.csrfTokenName] = window.jwsdwSettings.csrfTokenValue;
                payload.sessionAttribute = 'isSaizCustomer';
                payload.customerAttribute = 'hasUsedSaizTool';

                $.ajax({
                    url: window.jwsdwSettings.updatePromotionRelatedOptionsUrl,
                    method: 'POST',
                    data: payload,
                    dataType: 'json',
                    success: function () {
                        localStorage.setItem('isSaizCustomer', 'true');
                    },
                    error: function () {
                        localStorage.setItem('isSaizCustomer', 'false');
                    }
                });
            }
        });
    }
}(window, document, jQuery, Swiper)); // eslint-disable-line no-undef
